export default __webpack_public_path__ + "static/media/74-min.9c52960d.jpg";